export const selectAnnotationHistory = (state) =>
  state.annotationHistory.history;
export const selectCurrentTarget = (state) =>
  state.annotationHistory.currentTarget;

export const selectToogleUndoRedoSelector = (state) =>
  state.annotationHistory.toggleUndoRedo;
